export default {
    zh: {
        isGift: "是否赠品",
        dummyCode: 'Dummy编码',
        settlementUnitName: '结算单位名称',
        fiveBitCode: 'GRI编码',
        invitationCode: '供应商邀请码',
        settlementUnitCode: '结算单位编码',
        status: '启用状态',
        conductStatus: '状态',
        isSrmIssue: 'SRM物料信息是否下发',
        isExFactoryPriceIssue: '物料出厂价是否下发',
        isInboundFreightIssue: 'Inbound运费是否下发',
        isOutboundFreightIssue: 'outbound运费是否下发',
        isMdmReceive: 'MDM物料信息是否接收',
        isExFactoryPriceReceive: '物料出厂价是否接收',
        isMaterialInboundIssue: '物料Inbound 运费是否接收',
        isMaterialInboundIssueI18n: '物料outbound 运费是否接收',
        isStraightFreightIssueI18n: '直送运费是否下发',
        isFreightReceivedMdmI18n: '直送运费是否接受',
        mdmDataReleaseDate: 'MDM数据下发日期',
        isExFactoryPriceReceiveI18n: 'MDM数据是否接受',
        fpaBeginEffectiveDate: 'FPA起始有效期',
        issuePriceTakeEffectDate: '手工指定生效日期',
        isReceivePriceTouchI18n: '数据下放是否接受',
        see: '查看',
        lssueLog: '下发日志',
        GRICode: 'GRI编码',
        categoryLevel1Name: 'GRI第一层分类',
        categoryLevel2Name: 'GRI第二层分类',
        categoryLevel3Name: 'GRI第三层分类',
        fiveBitCodeName: 'GRI名称',
        describe: 'GRI描述',
        fromEffectiveDate: '起始有效日期',
        invalidDate: '无效日期',
        inventoryCountingFrequency: '存货盘点频率',
        menuType: '菜单类别',
        storageCategory: '储存类别',
        standardCopiesUom: 'UOM标准生产份数',
        isDisplayBtrReport: '在BTR报告中显示',
        btrUsageArea: 'BTR使用区域',
        btrUnitMeasurement: 'BTR测量单位',
        materialGRIDetail: '物料主数据详细',
        DisplayAfterSave: '保存后显示',

        nowVersion: '现版本',
        contrast: '对比物料',
        edition: '版本',
        GrossWeightBigWeight: '产品外包装毛重必须大于净重',

        supplierCode: 'DC编码',
        supplierName: 'DC名称',
        showApproval: '审批',
        isConversionCoefficient: '修改折算系数',
        showContrast: '选择对比物物料',
        createParams: '采购信息',
        tmPlantId: '工厂ID',
        tmPlantName: '工厂名称',
        tmMaterial: '产品状态',
        showGriDialogFun: 'GRI',
        approvedBy: '是否LTO',
        selectApprovedBy: '提交审批人',
        LastVersion: '上个版本',
        ComparisonMaterial: '对比物料',
        basicInformation: '基础信息',
        chineseNameOfProduct: '产品中文名称',
        englishNameOfProduct: '产品英文名称',
        englishAbbreviationOfProduct: '产品英文简称',
        forStoreTier: '适用Store Tier',
        internalAndExternalAreas: '适用于店内外区域',
        purchasingCategory: '采购分类',
        settlementClassification: '结算分类',
        purchasingManager: '采购经理',
        rpEffectiveDate: 'RP生效日期',
        useArea: '使用区域',
        marketTime: '上市时间',
        taxClassificationCode: '税收分类编码',
        canCtcSettle: '是否CTC可结算',
        isCtcImport: '是否CTC进口',
        isCtcDirectMining: '是否CTC直采',
        remarks: '备注',
        storageInformation: '仓储信息',
        dcManagementUnit: 'DC库存管理单位',
        materialFactoryDetails: '物料工厂详情',
        importedOrNot: '是否进口',
        extendInventory: '是否延伸库存',
        originCountry: '原产地',
        conversionCoefficient: '折算系数',
        pickUpPeriod: '取货周期（天）',
        minimumOrders: '最小订单量',
        minimumOrderUnit: '最小订单单位',
        priceType: '价格类型',
        disType: '配送类型',
        factoryPriceIncludeFreight: '出厂价是否含运费',
        alternativeDc: '备选DC',
        exFactoryPrice: '出厂价格',
        exFactoryUnitPriceIncludingTax: '出厂含税单价',
        urchaseTaxRate: '采购税率',
        exFactoryExcUnitPrice: '出厂不含税单价',
        purchaseTax: '采购税额',
        Freight: 'Freight',
        priceEffectiveStartingTime: '价格有效起始日期',
        futureFactoryRequiredPrice: '需要填写未来出厂价',
        serviceChargePerToy: '每件玩具服务费',
        toyServiceFeeWithTax: '每件玩具服务费（含税）',
        toyServiceFeeTax: '每件玩具服务费税率',
        isExistsLineQuotation: '是否含有Inbound运费',
        outboundFreight: 'Outbound运费',
        PleaseSelectApproved: '请选择审批通过的数据',
        materialProductStatus: '物料产品状态',
        qualityInformation: '质量信息',
        freightInfo: '运费信息',
        wrinCode: 'WRIN编码',
        isTraceable: '是否可追溯',
        enterCatellaeSystem: '是否进入Catellae系统',
        productDetails: '产品详情',
        temperature: '储存环境',
        secondShelfLife: '第二保质期',
        secondShelfLifeUnit: '第二保质期单位',
        firstShelfLife: '第一保质期（天）',
        shelfLifeAfterThawing: '解冻后保质期',
        shelfLifeUnitAfterThawing: '解冻后保质期单位',
        thawingTime: '解冻时间（小时）',
        formula1: '配方1',
        formula2: '配方2',
        formula3: '配方3',
        formula4: '配方4',
        isNeedThaw: '是否需要解冻',
        isNeedPreparationTime: '是否需要准备时间',
        isHarmful: '是否有害',
        taste: '味道',
        shape: '形状',
        color: '颜色',
        validityDate: '有效期检查',
        onlineSecondShelfLife: '在线第二保质期',
        preparationMethod: '准备方法',
        preparationTime: '准备时间（小时）',
        minimumStorageTemperature: '最低保存温度',
        maximumStorageTemperature: '最高保存温度',
        yieldInformation: '应产率信息',
        mcdBuyingUnit: '麦当劳购买单位',
        uom: '计量单位',
        quantityUomInnerNum: '内包装内含UOM数量',
        quantityUomOutsourceNum: '外包装内含UOM数量',
        quantityInnerGoodsNum: '内包装物品数量',
        outerPackageContainsNum: '外包装内含内包装数量',
        stackingHeightInsidePackage: '外包装内堆积高度',
        quantityInnerPackingNum: '内包装数量',
        yield: '应产率',
        preferentialYield: '偏好应产率',
        packagingInformation: '包装信息',
        isInnerPacking: '是否有内包装',
        productLength: '产品长度(cm)',
        productWidth: '产品宽度(cm)',
        productHeight: '产品高度(cm)',
        productWeight: '产品净重(kg)',
        productGrossWeight: '产品毛重(kg)',
        innerPackingType: '产品内包装类型',
        innerPackageLength: '产品内包装长度(cm)',
        innerPackingWidth: '产品内包装宽度(cm)',
        innerPackingHeight: '产品内包装高度(cm)',
        innerPackingWeight: '产品内包装净重(kg)',
        innerPackingGrossWeight: '产品内包装毛重(kg)',
        innerPackingCapacity: '产品内包装容量(m^3)',
        language: '语言',
        graphics: '绘图',
        productPackagingType: '产品外包装类型',
        externalPackagingLength: '产品外包装长度(cm)',
        externalPackagingWidth: '产品外包装宽度(cm)',
        externalPackagingHeight: '产品外包装高度(cm)',
        externalPackagingNetweight: '产品外包装净重(kg)',
        externalPackagingGrossweight: '产品外包装毛重(kg)',
        productTransportPalletType: '产品运输托盘类型',
        palletLayerBoxNumber: '每层箱数',
        palletLayerNumber: '托盘层数',
        palletItemsLength: '托盘上物品长度(cm)',
        palletItemsWidth: '托盘上物品宽度(cm)',
        palletItemsHeight: '托盘上物品高度(cm)',
        palletItemsWeight: '托盘上物品净重(kg)',
        palletItemsGrossWeight: '托盘上物品毛重(kg)',
        transportStackingLayers: '运输堆叠层数',
        storageStackLayersNum: '储存堆叠层数',
        transportHeight: '运输高度',
        storageHeight: '存储高度',
        weightUnit: '重量计算单位',
        minimumDcReceivingValidity: '最小DC收货有效期(天)',
        isFresh: '是否鲜货',
        affiliatedFactory: '关联工厂',
        supplier: '供应商名称',
        determine: '确定',
        listOfAttachments: '附件列表',
        add: '新增',
        primary: '新增玩具物料',
        new_unconventional_materials: '新增非常规物料',
        new_conventional_material: '新增紧急物料',
        isConventionalMaterial: '是否为紧急创建物料',
        material_data_decentralization_MDM: 'MDM下发SAP',
        DataSyncMDM: '数据同步MDM',
        material_list_download_full_volume: '列表下载（全量）',
        material_information_copy: '复制创建',
        material_historical_version_download: '历史版本下载',
        downloadAllNew: '最新版本下载',
        infoForm: '请选择',
        tyep: '类别',
        searchBox_top: '物料主数据GRI详情',
        tmPlant: '工厂',
        plantCode: '工厂编码',
        showSettlementUnitDialog: '结算单位',
        approvalDescription: '不通过，需要填写审批备注',
        required: '请填写必填的数据',
        approved: '只能选择审核通过的数据',
        sumsSort: 'SUMSSort',
        specifiUom: 'SpecifiUOM',
        projectOrCategoryLeader: 'ProjectLeade/CategoryLeader',
        department: 'Department',
        formarkets: 'ForMarkets',
        futureExWorksNotTax: 'Future Ex Works Cost/Case (w/o tax)',
        futureExWorksWithTax: 'Future Ex Works Cost/Case (with tax)',
        futurePriceEffectiveDate: 'FuturePriceEffectiveDate',
        futurePurchaseTaxAmount: 'FuturePurchaseTaxAmount',
        previousExWorks: 'Previous Ex Works Cost/Case',
        ptoyServiceFeeApplicable: 'Toy Service Fee Applicable',
        sizeMm: 'SizeMM',
        MaterialTemplate: '物料填写说明',
        seeattachment: '查看附件',
        FPARueryPop: 'FPA查询弹窗',
        fpaNo: 'FPA编号',
        validFrom: '未来开始时间',
        isIssued: '是否已下发',
        issueTime: '下发时间',
        eightBitCode: '物料编号',
        eightBitCodeName: '物料名称',
        newPricePerUom: '未来有效价格',
        updateDate: '审批通过时间',
        manualAssignmentDate: '手工指定有效期',
        mdmSynchronizationDate: 'MDM同步日期',
        statusDisable: '禁用',
        isReset: '是否需要重置已下发状态',
        yesDisable: 'FPA已禁用，无法下发',
        Reissue: '当前FPA是否需要重新下发',
        Issued: '当前FPA价格已下发，若需重新下发，请点击重置',
        firstDataSyncMDM: '请先将数据同步至MDM',
        IssuedLastMonth: '下发上个月',
        IssuedMonth: '下发当月',
        IssuedNextMonth: '下发下个月',
        pleaseIssuePriceTakeEffectDate: '请选择手工指定有效期',
        PricDistributionLog: '价格下发日志',
        PriceStartTime: '价格开始时间',
        FPAApprovalTime: 'FPA审批通过时间',
        selSupplierTitle: '选择GRI',
        HasMultiShelfLife: "多保质期标识",
        StopSaleDate: "停售日期",
    },
    en: {
        HasMultiShelfLife: "HasMultiShelfLife",
        StopSaleDate: "StopSaleDate",
        GRICode: 'fiveBitCodeName',
        categoryLevel1Name: 'categoryLevel1Name',
        categoryLevel2Name: 'categoryLevel2Name',
        categoryLevel3Name: 'categoryLevel3Name',
        fiveBitCodeName: 'fiveBitCodeName',
        describe: 'describe',
        fromEffectiveDate: 'fromEffectiveDate',
        invalidDate: 'invalidDate',
        inventoryCountingFrequency: 'inventoryCountingFrequency',
        menuType: 'menuType',
        storageCategory: 'storageCategory',
        standardCopiesUom: 'standardCopiesUom',
        isDisplayBtrReport: 'isDisplayBtrReport',
        btrUsageArea: 'btrUsageArea',
        btrUnitMeasurement: 'btrUnitMeasurement',
        materialGRIDetail: 'materialGRIDetail',
        DisplayAfterSave: 'DisplayAfterSave',
        GrossWeightBigWeight: 'GrossWeightBigWeight',
        isGift: "Is Gift",
    }
}